import PropTypes from 'prop-types'

/*
EXAMPLE:
{
  id: 'ABC',
  level: 3,
  scope: 'scope',
}
*/

export default PropTypes.shape({
  id: PropTypes.string.isRequired,
  level: PropTypes.number,
  scope: PropTypes.string,
})
